var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasure32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.293 9H21V8h7.293l-2.647-2.646.707-.707L30.207 8.5l-3.854 3.854-.707-.707zm-21.94 2.646L3.708 9H11V8H3.707l2.647-2.646-.707-.707L1.793 8.5l3.854 3.854zM2 17h28v9H2zm1 8h2v-4h1v4h1v-2h1v2h1v-6h1v6h1v-2h1v2h1v-4h1v4h1v-2h1v2h1v-6h1v6h1v-2h1v2h1v-4h1v4h1v-2h1v2h1v-6h1v6h1v-2h1v2h1v-7H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure32);
export default __webpack_public_path__ + "static/media/measure-32.750a2606601d3c7ff69a4e933a2ce8c2.svg";
export { ForwardRef as ReactComponent };